/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosHeaders, AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { contentType, getStorage } from 'utils';
import { EContentType } from './api';
import { API_BASE_URL, APP_REFRESH_TOKEN_NAME, APP_TOKEN_NAME } from './constants';

export default function HttpRequest() {

  const onRequestSuccess = (config: InternalAxiosRequestConfig) => {
    const auth = getStorage(APP_TOKEN_NAME);
    if (auth) {
      (config.headers as AxiosHeaders).set("Authorization", `Bearer ${auth}`);
    }
    return config;
  };

  const onResponseSuccess = (response: AxiosResponse) => {
    return response;
  };

  const onResponseError = (error: AxiosError) => {
    if (error.response?.status !== 401) {
      return Promise.reject(error);
    }
    return refreshToken(error);
  };

  let countNumber = 0;
  const refreshToken = async (error: AxiosError) => {
    if (!refreshToken) {
      localStorage.clear();
      window.location.replace('/');
      return;
    }

    const refreshTokenGetFromLocal = localStorage.getItem(APP_REFRESH_TOKEN_NAME)?.replaceAll('"', '');
    const response: any = await axios({
      method: 'post',
      url: `${API_BASE_URL}/auth/refresh`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        refresh_token: refreshTokenGetFromLocal
      }
    }).catch((err: any) => {
      localStorage.clear();
      sessionStorage.clear();
      return;
    })

    countNumber++;
    if (response.status === 200) {
      countNumber = 0;
    }

    localStorage.setItem(APP_TOKEN_NAME, response.data.access_token);
    localStorage.setItem(APP_REFRESH_TOKEN_NAME, response.data.refresh_token);
    let headers;
    if (error && error.config) {
      if (error.config.data) {
        if (error.config!.data instanceof FormData) {
          headers = Object.assign(
            headers ?? {},
            contentType(EContentType.BINARY)
          );
        } else {
          headers = Object.assign(
            headers ?? {},
            contentType(EContentType.JSON)
          );
          error.config!.data = JSON.parse(error.config?.data);
        }
        if (typeof error.config.data === 'string') {
          try {
            error.config.data = JSON.parse(error.config.data);
          } catch (e) {
            //
          }
        }
      }
    }
    if (countNumber > 3) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace('/');
      return;
    }
    error.config!.headers = {
      ...headers,
      Authorization: 'Bearer ' + response.data.access_token,
    } as AxiosRequestHeaders;
    return axios(error.config!);
  };

  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);

  return axios;
}
